module.exports = __webpack_public_path__ + "static/img/docman.96ea913.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/docman.jpg
// module id = OquI
// module chunks = 1